const TENANTS_NAMES = {
  intraser: 'intraser',
  acme: 'acme',
  ontruck: 'ontruck',
  xpo: 'xpo',
};

const HOST_LIST = {
  // Acme (test)
  [process.env.REACT_APP_ACME_LOCAL_HOST]: TENANTS_NAMES.acme,
  [process.env.REACT_APP_ACME_STAGING_HOST]: TENANTS_NAMES.acme,
  [process.env.REACT_APP_ACME_PRODUCTION_HOST]: TENANTS_NAMES.acme,
  // Ontruckp
  [process.env.REACT_APP_LOCAL_HOST]: TENANTS_NAMES.ontruck,
  [process.env.REACT_APP_STAGING_HOST]: TENANTS_NAMES.ontruck,
  [process.env.REACT_APP_PRODUCTION_HOST]: TENANTS_NAMES.ontruck,
  // Intraser
  [process.env.REACT_APP_INTRASER_LOCAL_HOST]: TENANTS_NAMES.intraser,
  [process.env.REACT_APP_INTRASER_STAGING_HOST]: TENANTS_NAMES.intraser,
  [process.env.REACT_APP_INTRASER_PRODUCTION_HOST]: TENANTS_NAMES.intraser,
  // Xpo
  [process.env.REACT_APP_XPO_LOCAL_HOST]: TENANTS_NAMES.xpo,
  [process.env.REACT_APP_XPO_STAGING_HOST]: TENANTS_NAMES.xpo,
  [process.env.REACT_APP_XPO_PRODUCTION_HOST]: TENANTS_NAMES.xpo,
};
const HOST = HOST_LIST[window.location.host] || TENANTS_NAMES.ontruck;

const API_URLS = {
  [TENANTS_NAMES.acme]: process.env.REACT_APP_ACME_API_URL,
  [TENANTS_NAMES.intraser]: process.env.REACT_APP_INTRASER_API_URL,
  [TENANTS_NAMES.xpo]: process.env.REACT_APP_XPO_API_URL,
  [TENANTS_NAMES.ontruck]: process.env.REACT_APP_API_URL,
};
const API_URL = API_URLS[HOST];

export { TENANTS_NAMES, HOST, API_URL };
